import React from 'react';
import { useParams } from 'react-router-dom';
import { GroundTruthAudit } from './GroundTruthAudit';

export const GroundTruthAuditPage: React.FC = () => {
  const { gtInferenceId } = useParams<{ gtInferenceId: string }>();

  return <GroundTruthAudit key={gtInferenceId} gtInferenceId={gtInferenceId ?? null} />;
};
